import {
  FETCH_TERMS_LOADING,
  FETCH_TERMS_SUCCESS,
  FETCH_TERMS_FAILED,
} from "../types";

export interface TermsAndConditionResponse {
  version: string;
  htmlTemplate: string;
  lastUpdated: string;
}

interface TermsState {
  loading: boolean;
  data: TermsAndConditionResponse | null;
  error: any;
}

const initialState: TermsState = {
  loading: false,
  data: null,
  error: null,
};

export default function latestTermsReducer(
  state = initialState,
  action: { type: string; loading?: boolean; payload?: any; error?: any }
): TermsState {
  switch (action.type) {
    case FETCH_TERMS_LOADING:
      return { ...state, loading: action.loading ?? true, error: null };
    case FETCH_TERMS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case FETCH_TERMS_FAILED:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
